import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitonagpurcab() {



    const cardData = {

keyword: "Mumbai to Nagpur Cab",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Mumbai to Nagpur Cab services for business travel, family trips, corporate journeys, educational travel, pilgrimage tours, and one-way or round-trip transportation. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup across Mumbai, and safe long-distance highway travel, we ensure a smooth, comfortable, and hassle-free journey from Mumbai to Nagpur and nearby destinations across Maharashtra.",

topPlaces: [
    {
        title: "Deekshabhoomi",
        description:
            "Deekshabhoomi is one of the most important spiritual and historical landmarks in Nagpur, where Dr. B. R. Ambedkar embraced Buddhism along with thousands of followers. The magnificent stupa attracts visitors from across India and abroad who come to learn about its historical significance, experience its peaceful surroundings, and participate in important cultural and religious events held throughout the year."
    },
    {
        title: "Zero Mile Stone",
        description:
            "Zero Mile Stone is a famous monument that symbolizes the geographical center of colonial India and remains one of Nagpur's most recognized landmarks. Visitors frequently stop here to explore its historical importance, admire the monument's architecture, and take photographs at a location that represents an important part of India's surveying and transportation history."
    },
    {
        title: "Ramtek Temple",
        description:
            "Ramtek Temple is a revered pilgrimage destination located on a hilltop near Nagpur and is associated with Lord Rama. The temple offers stunning panoramic views of the surrounding landscape and attracts devotees seeking spiritual blessings. Its historical importance, peaceful atmosphere, and scenic location make it one of the most popular attractions near Nagpur."
    },
    {
        title: "Ambazari Lake",
        description:
            "Ambazari Lake is one of Nagpur's largest and most beautiful lakes, offering boating facilities, walking paths, gardens, and recreational activities for visitors of all ages. Families, tourists, and local residents visit the lake to enjoy peaceful evenings, scenic views, and a refreshing escape from the busy city environment."
    },
    {
        title: "Futala Lake",
        description:
            "Futala Lake is a popular waterfront destination known for its illuminated fountains, vibrant atmosphere, food stalls, and picturesque sunset views. The lake attracts large numbers of visitors who come to relax, enjoy local cuisine, and spend quality time with family and friends while experiencing one of Nagpur's most lively public spaces."
    },
    {
        title: "Dragon Palace Temple",
        description:
            "Dragon Palace Temple is a magnificent Buddhist temple located near Nagpur and is admired for its beautiful architecture, serene surroundings, and spiritual ambiance. The temple attracts both devotees and tourists who seek meditation, peace, and an opportunity to experience one of the region's most significant Buddhist landmarks."
    },
    {
        title: "Pench National Park",
        description:
            "Pench National Park is one of India's premier wildlife destinations and is famous for its rich biodiversity, tiger population, and scenic forest landscapes. Nature lovers and wildlife enthusiasts traveling from Mumbai often visit Pench for jeep safaris, birdwatching, photography, and unforgettable encounters with wildlife in their natural habitat."
    },
    {
        title: "Mansar Lake",
        description:
            "Mansar Lake is a beautiful historical and archaeological destination located near Nagpur. The area is known for ancient temple remains, peaceful natural surroundings, and cultural significance. Visitors enjoy exploring the archaeological sites while experiencing the scenic beauty and tranquility that make Mansar a popular excursion spot."
    },
    {
        title: "Adasa Ganpati Temple",
        description:
            "Adasa Ganpati Temple is one of the most revered Lord Ganesha temples near Nagpur and is famous for its massive idol and religious importance. Devotees visit the temple throughout the year to seek blessings, participate in festivals, and experience the spiritual atmosphere that surrounds this sacred pilgrimage destination."
    },
    {
        title: "Tadoba-Andhari Tiger Reserve",
        description:
            "Tadoba-Andhari Tiger Reserve is Maharashtra's oldest and most celebrated tiger reserve, attracting wildlife enthusiasts from around the world. Known for excellent tiger sightings, diverse wildlife, dense forests, and thrilling safari experiences, Tadoba is a must-visit destination for travelers seeking adventure, photography opportunities, and close encounters with nature."
    }
],



services: [
{
name: "Mumbai to Nagpur Cab Booking",
description: "Mumbai to Nagpur Cab Booking by 1Touch Cabs provides reliable and comfortable long-distance transportation for families, business travelers, tourists, students, and corporate clients. We offer Sedan, SUV, Innova, Innova Crysta, Ertiga, Kia Carens, and Tempo Traveller vehicles driven by experienced chauffeurs. Whether you are planning a business trip, family visit, relocation journey, holiday travel, or emergency travel, our service ensures timely pickups, safe highway driving, comfortable seating, and transparent pricing. With 24x7 booking assistance, professional drivers, well-maintained vehicles, and dedicated customer support, we make travel between Mumbai and Nagpur convenient, affordable, and completely hassle-free."
},
{
name: "Mumbai to Nagpur Cab Service",
description: "Mumbai to Nagpur Cab Service offers dependable intercity transportation for passengers seeking safe and comfortable travel. 1Touch Cabs provides clean vehicles, professional chauffeurs, flexible pickup locations, and customized travel schedules. Our service focuses on passenger comfort, safety, punctuality, and reliable transportation throughout the journey."
},
{
name: "Mumbai to Nagpur Taxi",
description: "Mumbai to Nagpur Taxi service provides convenient road transportation with experienced drivers and air-conditioned vehicles. 1Touch Cabs offers one-way and round-trip travel options, affordable pricing, and comfortable rides for individuals, families, and business travelers. We ensure smooth travel and excellent customer satisfaction."
},
{
name: "Mumbai to Nagpur Cab",
description: "Mumbai to Nagpur Cab service delivers comfortable and efficient transportation between Mumbai and Nagpur. 1Touch Cabs offers a wide range of vehicles suitable for solo travelers, families, and groups. Our professional chauffeurs ensure safe travel, timely arrivals, and a pleasant journey experience."
},
{
name: "Mumbai to Nagpur Taxi Service",
description: "Mumbai to Nagpur Taxi Service provides reliable travel solutions for business trips, family vacations, corporate travel, and personal journeys. 1Touch Cabs offers well-maintained vehicles, professional drivers, transparent fares, and round-the-clock booking support. We ensure dependable service from pickup to destination."
},
{
name: "Mumbai to Nagpur One Way Cab",
description: "Mumbai to Nagpur One Way Cab service offers affordable transportation without return fare charges. 1Touch Cabs provides economical pricing, comfortable vehicles, and experienced chauffeurs for passengers who need one-way travel. Our service ensures convenience, value, and dependable transportation."
},
{
name: "Mumbai to Nagpur Cab Booking",
description: "Mumbai to Nagpur Cab Booking service allows travelers to reserve their cab quickly and conveniently. 1Touch Cabs provides instant booking confirmation, multiple vehicle options, transparent pricing, and dedicated customer support. We make long-distance travel planning simple and stress-free."
},
{
name: "Mumbai to Nagpur Car Rental",
description: "Mumbai to Nagpur Car Rental service offers flexible transportation solutions for personal, family, and corporate travel. 1Touch Cabs provides a variety of vehicle choices, professional chauffeurs, and affordable rental packages. We ensure comfortable and reliable travel for every passenger."
},
{
name: "Mumbai to Nagpur Outstation Cab",
description: "Mumbai to Nagpur Outstation Cab service provides safe and dependable long-distance transportation with professional drivers and comfortable vehicles. 1Touch Cabs offers customized travel schedules, transparent pricing, and excellent customer support for smooth intercity travel."
},
{
name: "Mumbai to Nagpur Private Taxi",
description: "Mumbai to Nagpur Private Taxi service offers exclusive transportation for passengers seeking privacy, flexibility, and convenience. 1Touch Cabs provides dedicated vehicles, personalized travel schedules, and experienced chauffeurs. We ensure a comfortable and stress-free travel experience."
},
{
name: "Mumbai to Nagpur Innova Cab",
description: "Mumbai to Nagpur Innova Cab service provides spacious and comfortable transportation for families, business travelers, and groups. 1Touch Cabs offers well-maintained Innova vehicles, professional chauffeurs, and reliable travel support. We ensure superior comfort during long-distance journeys."
},
{
name: "Mumbai to Nagpur Innova Crysta Cab",
description: "Mumbai to Nagpur Innova Crysta Cab service offers premium travel comfort with luxury seating, spacious interiors, and ample luggage capacity. 1Touch Cabs provides experienced chauffeurs and high-quality vehicles for a smooth, comfortable, and enjoyable travel experience."
},
{
name: "Mumbai to Nagpur Ertiga Cab",
description: "Mumbai to Nagpur Ertiga Cab service offers economical and comfortable transportation for families and small groups. 1Touch Cabs provides clean air-conditioned vehicles, professional drivers, and flexible travel options. We ensure safe and affordable intercity transportation."
},
{
name: "Mumbai to Nagpur Sedan Cab",
description: "Mumbai to Nagpur Sedan Cab service provides comfortable and budget-friendly travel for individuals, couples, and small families. 1Touch Cabs offers well-maintained sedan vehicles, experienced chauffeurs, and reliable service. We ensure smooth travel with maximum convenience."
},
{
name: "Mumbai to Nagpur Swift Dzire Cab",
description: "Mumbai to Nagpur Swift Dzire Cab service offers affordable long-distance transportation with comfortable seating and professional chauffeur support. 1Touch Cabs provides dependable vehicles, transparent pricing, and excellent customer service for every journey."
},
{
name: "Mumbai to Nagpur SUV Taxi",
description: "Mumbai to Nagpur SUV Taxi service provides spacious and comfortable transportation for larger families, groups, and travelers carrying extra luggage. 1Touch Cabs offers premium SUV vehicles, professional drivers, and safe highway travel for long-distance journeys."
},
{
name: "Mumbai to Nagpur Kia Carens Cab",
description: "Mumbai to Nagpur Kia Carens Cab service offers premium comfort and spacious seating for families and groups. 1Touch Cabs provides modern vehicles, experienced chauffeurs, and dependable transportation. We ensure a relaxing and enjoyable journey from Mumbai to Nagpur."
},
{
name: "Mumbai to Nagpur Luxury Cab",
description: "Mumbai to Nagpur Luxury Cab service provides premium transportation with high-end vehicles, professional chauffeurs, and exceptional travel comfort. 1Touch Cabs offers executive travel solutions for business travelers, VIP clients, and families seeking luxury road travel."
},
{
name: "Mumbai to Nagpur AC Taxi",
description: "Mumbai to Nagpur AC Taxi service offers fully air-conditioned transportation for comfortable travel throughout the journey. 1Touch Cabs provides clean vehicles, professional drivers, and reliable service. We ensure a pleasant and refreshing travel experience in every season."
},
{
name: "Mumbai to Nagpur Tempo Traveller",
description: "Mumbai to Nagpur Tempo Traveller service is ideal for group tours, family trips, corporate outings, and pilgrimage journeys. 1Touch Cabs offers spacious Tempo Travellers with comfortable seating, professional chauffeurs, and dependable travel arrangements for larger groups."
},
{
name: "Mumbai Airport to Nagpur Cab",
description: "Mumbai Airport to Nagpur Cab service provides direct transportation for passengers arriving at Mumbai Airport. 1Touch Cabs offers timely pickups, luggage assistance, professional chauffeurs, and comfortable vehicles. We ensure seamless airport-to-destination travel."
},
{
name: "Mumbai International Airport to Nagpur Cab",
description: "Mumbai International Airport to Nagpur Cab service offers reliable airport transfer solutions for domestic and international travelers. 1Touch Cabs provides comfortable vehicles, experienced drivers, and punctual service. We ensure convenient long-distance transportation from the airport."
},
{
name: "Navi Mumbai to Nagpur Cab",
description: "Navi Mumbai to Nagpur Cab service provides dependable transportation from all areas of Navi Mumbai to Nagpur. 1Touch Cabs offers multiple vehicle options, professional chauffeurs, and affordable travel packages. We ensure safe and comfortable intercity journeys."
},
{
name: "Thane to Nagpur Cab",
description: "Thane to Nagpur Cab service offers convenient long-distance transportation with professional drivers and well-maintained vehicles. 1Touch Cabs provides reliable travel arrangements, comfortable seating, and affordable fares. We ensure a smooth and enjoyable journey."
},
{
name: "Panvel to Nagpur Taxi",
description: "Panvel to Nagpur Taxi service provides direct transportation for families, business travelers, and tourists traveling to Nagpur. 1Touch Cabs offers clean vehicles, experienced chauffeurs, transparent pricing, and dependable support. We ensure safe and comfortable travel from Panvel to Nagpur."
}
],

tableData: [
["Mumbai to Nagpur Cab Booking","Mumbai to Nagpur Cab Service"],
["Mumbai to Nagpur Taxi","Mumbai to Nagpur Cab"],
["Mumbai to Nagpur Taxi Service","Mumbai to Nagpur One Way Cab"],
["Mumbai to Nagpur Car Rental","Mumbai to Nagpur Outstation Cab"],
["Mumbai to Nagpur Private Taxi","Mumbai to Nagpur Innova Cab"],
["Mumbai to Nagpur Innova Crysta Cab","Mumbai to Nagpur Ertiga Cab"],
["Mumbai to Nagpur Sedan Cab","Mumbai to Nagpur Swift Dzire Cab"],
["Mumbai to Nagpur SUV Taxi","Mumbai to Nagpur Kia Carens Cab"],
["Mumbai to Nagpur Luxury Cab","Mumbai to Nagpur AC Taxi"],
["Mumbai to Nagpur Tempo Traveller","Mumbai Airport to Nagpur Cab"],
["Mumbai International Airport to Nagpur Cab","Navi Mumbai to Nagpur Cab"],
["Thane to Nagpur Cab","Panvel to Nagpur Taxi"]
],












whychoose: [
    {
        WhyChooseheading: "Reliable Mumbai to Nagpur Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Nagpur Cab services for business travelers, families, students, corporate professionals, tourists, and long-distance travelers seeking comfortable transportation."
    },
    {
        WhyChooseheading: "Comfortable Long-Distance Travel Experience",
        WhyChoosedescription: "Travel conveniently from Mumbai to Nagpur with well-maintained vehicles, experienced drivers, and flexible travel schedules designed for a stress-free journey."
    },
    {
        WhyChooseheading: "Perfect for Business and Personal Travel",
        WhyChoosedescription: "Nagpur is a major commercial, educational, and industrial hub, making it a preferred destination for business meetings, academic visits, family trips, and official travel."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Booking Available",
        WhyChoosedescription: "Whether you need a one-way cab, round trip, multi-day business travel, or customized tour package, we provide flexible booking options."
    },
    {
        WhyChooseheading: "Pickup Available Across Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Kalyan, Dombivli, Andheri, Borivali, Bandra, Dadar, Powai, and nearby locations."
    },
    {
        WhyChooseheading: "Professional Drivers for Interstate Travel",
        WhyChoosedescription: "Our experienced chauffeurs are familiar with Maharashtra interstate routes and ensure safe, smooth, and comfortable transportation throughout the journey."
    },
    {
        WhyChooseheading: "Ideal for Families, Students, and Corporate Travelers",
        WhyChoosedescription: "From family visits and educational travel to business tours and corporate requirements, we provide suitable vehicles for every travel need."
    }
]
};

const faqData = [
    {
        question: "Why do travelers book Mumbai to Nagpur Cabs?",
        answer: "Nagpur attracts visitors for business meetings, educational institutions, government work, family visits, tourism, and industrial travel."
    },
    {
        question: "Can I book a one-way cab from Mumbai to Nagpur?",
        answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicle is suitable for Mumbai to Nagpur travel?",
        answer: "Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available according to passenger count and travel preferences."
    },
    {
        question: "Can corporate travelers use this service regularly?",
        answer: "Yes, many business professionals, company executives, consultants, and corporate teams use our Mumbai to Nagpur cab services."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, educational tours, corporate teams, and tourist groups."
    },
    {
        question: "Can multiple stops be included during the trip?",
        answer: "Yes, customers can customize their itinerary and include business locations, tourist attractions, hotels, restaurants, and personal stops."
    },
    {
        question: "Can students book cabs for educational travel?",
        answer: "Yes, students and parents frequently use our cab services for college admissions, university visits, and educational travel."
    },
    {
        question: "Can I get pickup from Mumbai Airport?",
        answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
    },
    {
        question: "Is advance booking recommended for Mumbai to Nagpur travel?",
        answer: "Yes, advance booking is recommended to secure your preferred vehicle, especially during holidays, festivals, and peak travel seasons."
    },
    {
        question: "How can I book a Mumbai to Nagpur Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rajiv Wankhede",
        feedback:
            "I frequently travel between Mumbai and Nagpur for business purposes. Mumbai Airport Cabs always provides reliable service, comfortable vehicles, and professional drivers.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Sneha Deshpande",
        feedback:
            "Our family trip to Nagpur was extremely comfortable. The cab was clean, spacious, and the driver ensured a safe and pleasant journey throughout the trip.",
        rating: 5
    }
];




















   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Nagpur Cab Service",
  "image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-nagpur-cab.jpg",
  "description": "Book Mumbai to Nagpur cab service for safe, comfortable, and reliable long-distance travel. Mumbai Airport Cabs offers affordable one-way and round-trip taxi service with professional drivers, clean AC vehicles, and 24x7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Mumbai Airport Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.mumbaiairportcabs.com/mumbai-to-nagpur-cab"
  }
};








    return (
        <div>

<Helmet>
  <title>Mumbai to Nagpur Cab Service | Long Distance Taxi Booking | +91 9545731161</title>

  <meta
    name="description"
    content="Book Mumbai to Nagpur cab service for safe and comfortable travel. Affordable long-distance taxi with professional drivers and 24x7 booking support."
  />

  <meta
    name="keywords"
    content="Mumbai to Nagpur cab booking, Mumbai to Nagpur cab service, Mumbai to Nagpur taxi, Mumbai to Nagpur Cab, Mumbai to Nagpur Taxi, Mumbai to Nagpur Cab Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/11.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitonagpurcab;